var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, createStyles, makeStyles } from '@material-ui/core';
import React from 'react';
import BlockReservationHead from '../../components/BlockReservationHead';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        content: {
            backdropFilter: 'blur(4px)',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            overflowY: 'scroll',
            padding: theme.spacing(3, 6, 0, 6),
        },
    });
});
export default (function (_a) {
    var name = _a.name, address = _a.address, nbSessions = _a.nbSessions, distance = _a.distance, price = _a.price, children = _a.children, maxHeight = _a.maxHeight, onClose = _a.onClose, onSubmit = _a.onSubmit, submitDisabled = _a.submitDisabled;
    var styles = useStyle({});
    return (React.createElement(Box, null,
        React.createElement(BlockReservationHead, __assign({}, { name: name, address: address, nbSessions: nbSessions, distance: distance, price: price, onClose: onClose, onSubmit: onSubmit, submitDisabled: submitDisabled })),
        React.createElement(Box, { className: styles.content, maxHeight: maxHeight }, children)));
});
//# sourceMappingURL=index.js.map